import { BaseException, BaseExceptionContext } from './base.exception';

interface UnauthorizedExceptionContext extends BaseExceptionContext {}

export class UnauthorizedException extends BaseException {
  constructor(entity: string, context: UnauthorizedExceptionContext) {
    super(
      `Unauthorized access while performing operation on ${entity}`,
      context,
    );
  }
}
